import React, { useContext, useState } from 'react'
import * as Contentful from 'contentful'
import cn from 'classnames'
import { Tabs as BadgerTabs, Typography } from '@grammarly/badger-ui'

import { PageContext } from '../../../contexts/page-context'
import { PlacementContext } from '../../../contexts/placement-context'
import { CompactSectionsContext } from '../../../contexts/compact-sections-context'
import { useIsSectionThemeDark } from '../../../contexts/section-theme-context'
import { gnarSpec } from '../../../lib/tracking/gnar'

import styles from './tabs.module.scss'

const { C1 } = Typography

export const Tabs: React.FC<{ labels: Contentful.EntryFields.Symbol[]; content: JSX.Element[] }> = ({
  labels,
  content,
}) => {
  const { pageId, slug } = useContext(PageContext)
  const [activeTab, setActiveTab] = useState(0)
  const isDarkTheme = useIsSectionThemeDark()
  const { placement, placementInternalName } = useContext(PlacementContext)

  const smallScreenView = (
    <CompactSectionsContext.Provider value={true}>
      {labels.map((_, i) => {
        return <div key={i}>{content[i]}</div>
      })}
    </CompactSectionsContext.Provider>
  )

  const onTabChange = (index: number) => {
    setActiveTab(index)
    gnarSpec.tabButtonClick(pageId, slug, index, labels[index], placement, placementInternalName)
  }

  const defaultView = (
    <CompactSectionsContext.Provider value={true}>
      <BadgerTabs index={activeTab} onChange={onTabChange} id="controlledTabs">
        <BadgerTabs.TabList className={styles.tabLabels}>
          {labels.map((label, i) => {
            return (
              <BadgerTabs.Tab key={i} className={cn(styles.tabLabel, { [styles.dark]: isDarkTheme })}>
                <C1 as="span">{label}</C1>
              </BadgerTabs.Tab>
            )
          })}
        </BadgerTabs.TabList>
        <BadgerTabs.TabPanels>
          {content.map((c, i) => {
            return <BadgerTabs.TabPanel key={i}>{c}</BadgerTabs.TabPanel>
          })}
        </BadgerTabs.TabPanels>
      </BadgerTabs>
    </CompactSectionsContext.Provider>
  )

  return (
    <>
      <div className={styles.smallScreenView}>{smallScreenView}</div>
      <div className={styles.defaultView}>{defaultView}</div>
    </>
  )
}
